/**
 *  并发工具
 */

/**
 * 受控并发，受控的Promise.all
 * @param actions 待并发的操作，Array<() => Promise<any>>>
 * @param MAX_PARALLEL_SIZE 最大并发数，小于1则是全量并发
 * @returns {Promise<unknown>|Promise<unknown[]>} 同 Promise.all
 * @author youxin
 */
export const parallel = (actions, MAX_PARALLEL_SIZE = 0) => {
  // 全量并发
  if (MAX_PARALLEL_SIZE < 1 || MAX_PARALLEL_SIZE >= actions.length) {
    return Promise.all(actions.map((action) => action()));
  }

  return new Promise((resolve, reject) => {
    const results = [];
    let actionIndex = 0;
    const createThenHandler = (index) => (ret) => {
      results[index] = ret;

      if (index >= actions.length - 1) {
        resolve(results);
        return;
      }

      actionIndex += 1;
      if (actionIndex >= actions.length) return;

      const nextIndex = actionIndex;
      const nextP = actions[nextIndex]();
      nextP.then(createThenHandler(nextIndex)).catch(reject);
    };

    // 快速启动
    for (let i = 0; i < MAX_PARALLEL_SIZE; ++i, ++actionIndex) {
      const p = actions[actionIndex]();
      p.then(createThenHandler(actionIndex)).catch(reject);
    }
    actionIndex -= 1;
  });
};

/**
 * 同类操作拆分
 * @param elements 参数数组
 * @param segmentSize 单次操作携带的参数数组片段长度
 * @param action 操作器 (elementsSegment) => resultsSegment
 * @param MAX_PARALLEL_SIZE action并发数，默认全量并发
 * @returns {Promise<unknown[]>} 按序拼装后的请求结果，
 */
export const ripAction = (
  elements,
  segmentSize,
  action,
  MAX_PARALLEL_SIZE = 0
) => {
  const actions = [];
  for (let i = 0; ; ++i) {
    const elementsSegment = elements.slice(
      i * segmentSize,
      (i + 1) * segmentSize
    );
    if (!elementsSegment.length) break;
    actions.push(() => action(elementsSegment));
  }
  return parallel(actions, MAX_PARALLEL_SIZE);
};
